module.exports = __webpack_public_path__ + "static/media/12M_PAO_Symbol.5530a8bb.svg";